// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1769":"5dbd5654","9754":"e766ba8a"}[chunkId] + ".chunk.css";
};